module.exports = __webpack_public_path__ + "static/fonts/web-icons.f781255.eot";


//////////////////
// WEBPACK FOOTER
// ./static/material/global/fonts_b/web-icons/web-icons.eot?v=0.2.3
// module id = 1175
// module chunks = 0